import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ArrowDown: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        d='M12.75 16.19l3.72-3.72 1.06 1.06L12 19.06l-5.53-5.53 1.06-1.06 3.72 3.72V6h1.5v10.19z'
        fill='currentColor'
      />
    </svg>
  </i>
);

ArrowDown.displayName = 'ArrowDown';
export default ArrowDown;
